const MSC_LINE_ID = 16;
const NORWEGIAN_LINE_ID = 17;
const ROYAL_CARIBBEAN_LINE_ID = 22;
const DISNEY_LINE_ID = 73;

export const DEFAULT_CAUTION = [
  "상기 일정은 날씨(천재지변) 및 선사 사정에 따라서 사전 통보없이 변경될 수 있습니다.",
  "크루즈 출발시간 최소 3시간 전 항구에 도착하여 승선수속을 진행해야 하며, 귀국 항공편은 크루즈 도착 기준 약 5~6시간 이후로 예약",
  "현재 제공되는 일부 이미지 및 고객 안내사항은 선내 또는 기항지에서 요구되거나 제한되는 공중보건 규칙과 정부 요건을 정확하게 반영하지 못할 수 있습니다."
];

export const MSC_CAUTION = [
  { text: "상기 일정은 날씨(천재지변) 및 선사 사정에 따라서 사전 통보없이 변경될 수 있습니다." },
  { text: "크루즈 출발 최소 3시간 전 항구에 도착하여 승선수속을 진행해야 하며, 귀국 항공편은 크루즈 도착 기준 약 5~6시간 이후로 예약하시기 바랍니다." },
  { text: "현재 제공되는 일부 이미지 및 고객 안내사항은 선내 또는 기항지에서 요구되거나 제한되는 공중보건 규칙과 정부 요건을 정확하게 반영하지 못할 수 있습니다." },
  { text: "영문 성과 이름의 순서를 바꿔 기재하거나 철자에 오류가 있는 경우에도 '이름 변경'으로 간주되며, 1인당 USD $50 이름 변경 수수료가 부과됩니다. 예약일 ~ 출발일 14일 전(영업일 기준)까지만 요청이 가능합니다." },
  { text: "승선 서류 발급(출발일 기준 30일 전) 이후 이름 변경 시, 이름 변경 수수료 외에 승선 서류 재발행 수수료 USD $50이 추가 발생됩니다." },
  {
    text: "일정 변경",
    subItems: [
      "출발일 기준 30일 이전까지 접수되어야 하며, 예약한 프로모션에 따라 일정 변경 수수료가 상이합니다.",
      "벨라 : 1인당 $50",
      "판타스티카/ 오레아/요트클럽 : 1회 무료",
      "월드 크루즈 : 크루즈 요금의 15%",
      "신규 크루즈 출발일이 기존 크루즈 출발일로부터 90일 이내여야 합니다. 기존 크루즈 출발일보다 앞선 크루즈 일정으로의 변경은 불가합니다.",
      "신규 크루즈 출발일이 기존 크루즈 출발일로부터 91일 - 1년 이내인 경우, 프로모션 종류에 관계없이 인당 $50의 변경 수수료가 추가 부과됩니다.",
      "변경하고자 하는 일정의 크루즈 요금이 기존 요금보다 낮더라도 차액은 환불되지 않습니다.",
      "예약률이 매우 높거나 출발일 임박, 일정 마감 등 선사 사정에 따라 예약 변경이 불가능 할 수 있습니다."
    ]
  },
  {
    text: "선상팁",
    subItems: [
      "선상팁을 사전 지불하지 않는 경우 선사 규정에 따라 선상팁은 추후 변경될 수 있습니다.",
      "MSC 크루즈를 이용하는 모든 고객은 선상팁(Hotel Service Charge)을 지불해야 하며, 크루즈 일정 및 선실 등급, 예약 시점에 따라 선상팁 비용이 상이합니다. 예약 완료 단계 내 '추가서비스'에서 선상팁 금액 확인 및 선지불 선택이 가능합니다. 선상팁 후지불 선택 시, 추후 선사의 정책에 따라 금액이 변경될 수 있습니다.",
      "※ 아래 선상팁은 2026년 7월 2일 부터 신규 예약 건에 적용됩니다.",
      {
        text: "아시아 (중국, 일본, 대한민국)",
        subItems: [
          {
            text: "벨라 / 판타스티카 / 오레아 / 스위트",
            subItems: [
              "만 2세 이상 : 1인 1박당 $18",
              "만 2세 미만 : 무료"
            ]
          },
          {
            text: "MSC 요트클럽",
            subItems: [
              "만 2세 이상 : 1인 1박당 $21",
              "만 2세 미만 : 무료"
            ]
          }
        ]
      },
      {
        text: "지중해, 카나리아 제도, 북유럽, 앤틸리스 제도, 두바이, 에미레이트 및 오만, MSC 월드 크루즈, 홍해 크루즈",
        subItems: [
          {
            text: "벨라 / 판타스티카 / 오레아 / 스위트",
            subItems: [
              "만 18세 이상 : 1인 1박당 €12",
              "선내 통화가 GBP인 경우 : 1인 1박당 £11",
              "만 2세 - 17세 : 1인 1박당 €10",
              "선내 통화가 GBP인 경우 : 1인 1박당 £6",
              "만 2세 미만 : 무료"
            ]
          },
          {
            text: "MSC 요트클럽",
            subItems: [
              "만 18세 이상 : 1인 1박당 €16",
              "선내 통화가 GBP인 경우 : 1인 1박당 £14",
              "만 2세 - 17세 : 1인 1박당 €13",
              "선내 통화가 GBP인 경우 : 1인 1박당 £7",
              "만 2세 미만 : 무료"
            ]
          }
        ]
      },
      {
        text: "남아프리카 크루즈",
        subItems: [
          {
            text: "벨라 / 판타스티카 / 오레아 / 스위트",
            subItems: [
              "만 12세 이상 : 1인 1박당 $17",
              "만 2세 - 11세 : 1인 1박당 $9",
              "만 2세 미만 : 무료"
            ]
          },
          {
            text: "MSC 요트클럽",
            subItems: [
              "만 12세 이상 : 1인 1박당 $21",
              "만 2세 - 11세 : 1인 1박당 $11",
              "만 2세 미만 : 무료"
            ]
          }
        ]
      },
      {
        text: "남미 크루즈",
        subItems: [
          {
            text: "벨라 / 판타스티카 / 오레아 / 스위트",
            subItems: [
              "만 12세 이상 : 1인 1박당 $19",
              "만 2세 - 11세 : 1인 1박당 $13",
              "만 2세 미만 : 무료"
            ]
          },
          {
            text: "MSC 요트클럽",
            subItems: [
              "만 12세 이상 : 1인 1박당 $23",
              "만 2세 - 11세 : 1인 1박당 $16",
              "만 2세 미만 : 무료"
            ]
          }
        ]
      },
      {
        text: "카리브해, 알래스카, 미국 & 캐나다 크루즈",
        subItems: [
          {
            text: "벨라 / 판타스티카 / 오레아 / 스위트",
            subItems: [
              "만 2세 이상 : 1인 1박당 $17",
              "만 2세 미만 : 무료"
            ]
          },
          {
            text: "MSC 요트클럽",
            subItems: [
              "만 2세 이상 : 1인 1박당 $23",
              "만 2세 미만 : 무료"
            ]
          }
        ]
      },
      {
        text: "MSC 그랜드 보이지 (지중해, 북유럽, 두바이, 에미레이트 및 오만, 앤틸리스 제도, 홍해 및 아시아에서 출발)",
        subItems: [
          {
            text: "벨라 / 판타스티카 / 오레아 / 스위트",
            subItems: [
              "만 18세 이상 : 1인 1박당 €12",
              "만 2세 - 17세 : 1인 1박당 €10",
              "만 2세 미만 : 무료"
            ]
          },
          {
            text: "MSC 요트클럽",
            subItems: [
              "만 18세 이상 : 1인 1박당 €16",
              "만 2세 - 17세 : 1인 1박당 €13",
              "만 2세 미만 : 무료"
            ]
          }
        ]
      },
      {
        text: "MSC 그랜드 보이지 (남아프리카, 남미, 카리브해, 알래스카 출발 ※ 파나마 운하 일정 포함)",
        subItems: [
          {
            text: "벨라 / 판타스티카 / 오레아 / 스위트",
            subItems: [
              "만 18세 이상 : 1인 1박당 $17",
              "만 2세 - 17세 : 1인 1박당 $14",
              "만 2세 미만 : 무료"
            ]
          },
          {
            text: "MSC 요트클럽",
            subItems: [
              "만 18세 이상 : 1인 1박당 $21",
              "만 2세 - 17세 : 1인 1박당 $17",
              "만 2세 미만 : 무료"
            ]
          }
        ]
      }
    ]
  },
  {
    text: "미성년자 탑승 규정",
    subItems: [
      "원칙: 미성년자(만 18세이하) 승객은 최소 1명의 성인(Adult)과 동일 객실에 투숙해야 합니다.",
      "예외: 부모/법정대리인이 동반하지 않는 경우, 예약 시 예외 요청과 함께 부모/법정대리인의 동의서 및 지정 보호자 정보 등을 제출해야 합니다.",
      { type: "note", text: "*미국 출발 또는 미국을 여행(기항 포함)하는 크루즈의 경우 단독 여행은 만 21세 이상이어야 합니다." }
    ]
  },
  {
    text: "임산부 승선 규정",
    subItems: [
      "탑승 가능: 임신 주수가 23주 6일 이하인 경우에 한해, 의사 소견서 및 임신 주수 증빙서류를 승선(출항) 30일 전까지 제출하면 승선 가능합니다.",
      "탑승 불가: 크루즈 기간 중 어느 시점이든 임신 24 초과가 되는 경우, 안전상 승선이 거절됩니다."
    ]
  },
  {
    text: "휠체어 반입 규정",
    subItems: [
      "사전 신고 필수: 휠체어/스쿠터는 승선 전 반드시 최소 출발 30일 전 선사측에 신고해야 하며, 사전 신고가 없을 경우 승선/반입이 거절될 수 있습니다.",
      "배터리 규정: 전동 휠체어/스쿠터는 배터리 종류(젤·드라이·리튬 등)를 사전에 신고해야 하며, 습식(wet) 배터리는 반입이 금지됩니다.",
      "복도 보관 금지: 안전을 위해 복도/통로 보관은 불가하며, 객실 내 보관이 원칙입니다.",
      "선내 제공 휠체어 제한: 선사 제공 휠체어는 승·하선 또는 비상 상황에 한정되며, 상시 사용이 필요한 경우 개인 휠체어를 지참해야 합니다."
    ]
  }
];

export const NORWEGIAN_CAUTION = [
  { text: "상기 일정은 날씨(천재지변) 및 선사 사정에 따라서 사전 통보없이 변경될 수 있습니다." },
  { text: "크루즈 출발 최소 3시간 전 항구에 도착하여 승선수속을 진행해야 하며, 귀국 항공편은 크루즈 도착 기준 약 5~6시간 이후로 예약하시기 바랍니다." },
  { text: "현재 제공되는 일부 이미지 및 고객 안내사항은 선내 또는 기항지에서 요구되거나 제한되는 공중보건 규칙과 정부 요건을 정확하게 반영하지 못할 수 있습니다." },
  {
    text: "이름변경",
    subItems: [
      "출항일 기준 90일 전까지는 예약자 전원의 성명 변경이 가능합니다.",
      "출항일 기준 89일 전부터 15일 전까지는 1회에 한하여 성명 변경이 허용되며, 이 경우 예약자 중 최소 1인의 성명은 유지되어야 합니다.",
      "출항일 기준 14일 이내의 모든 성명 변경은 취소 규정에 따른 위약금이 적용됩니다."
    ]
  },
  {
    text: "선상팁",
    subItems: [
      "선상팁을 사전 지불하지 않는 경우 선사 규정에 따라 선상팁은 추후 변경될 수 있습니다.",
      "노르웨이지안 크루즈를 이용하는 모든 고객은 선상팁(Service Charge)을 지불해야하며, 선실 등급, 예약 시점에 따라 선상팁 비용이 상이합니다. 예약 완료 단계 내 '추가서비스'에서 선상팁 금액 확인 및 선지불 선택 가능합니다. 선상팁 후지불 선택 시, 추후 선사의 정책에 따라 금액이 변경 될 수 있습니다.",
      "선상팁은 만 3세 이상 모든 승객에게 동일하게 적용됩니다.",
      { type: "note", text: "2023년 1월 1일 이후 예약 건" },
      {
        text: "더 헤이븐(The Haven) 및 스위트 선실",
        subItems: [
          "1인 1박당 USD $25.00"
        ]
      },
      {
        text: "클럽 발코니 스위트 이하 선실",
        subItems: [
          "1인 1박당 USD $20.00"
        ]
      },
      { type: "note", text: "※ 하와이로 운항하는 크루즈의 경우, 사전 결제된 서비스 차지 금액에 4.712%의 하와이 일반소비세(GET)가 추가로 부과됩니다." }
    ]
  },
  {
    text: "미성년자 탑승 규정",
    subItems: [
      "미성년자(Minor) 기준: 승선일 기준 만 18세 미만",
      "청년(Young Adult) 구분: 만 18-20세",
      "원칙: 만 21세 미만(= 미성년자 & 18-20세) 승객은 최소 1명의 성인(Adult)과 동일 객실에 투숙해야 합니다.",
      "예외: 부모/법정대리인이 동반하지 않는 경우, 예약 시 예외 요청과 함께 부모/법정대리인의 동의서 및 지정 보호자 정보 등을 제출해야 합니다.",
      "만 18세 이상 두 사람이 부부(혼인 증빙)이면, 둘 다 만 21세 미만이어도 같은 객실 여행 가능합니다.",
      { type: "note", text: "*미국 출발 또는 미국을 여행(기항 포함)하는 크루즈의 경우 만 21세 이상 이어야 합니다." }
    ]
  },
  {
    text: "임산부 승선 규정",
    subItems: [
      "탑승 가능: 임신 주수가 24주차 이하인 경우에 한해, 의사 소견서 및 임신 주수 증빙서류를 승선(출항) 30일 전까지 제출하면 승선 가능합니다.",
      "탑승 불가: 크루즈 기간 중 어느 시점이든 임신 24 초과가 되는 경우, 안전상 승선이 거절됩니다."
    ]
  },
  {
    text: "휠체어 반입 규정",
    subItems: [
      "사전 신고 필수: 휠체어/스쿠터는 최소 승선 30일 전 반드시 선사 측에 신고해야 하며, 사전 신고가 없을 경우 승선/반입이 거절될 수 있습니다.",
      "복도 보관 금지: 안전을 위해 복도/통로 보관은 불가하며, 객실 내 보관이 원칙입니다."
    ]
  }
];

export const ROYAL_CARIBBEAN_CAUTION = [
  { text: "상기 일정은 날씨(천재지변) 및 선사 사정에 따라서 사전 통보없이 변경될 수 있습니다." },
  { text: "크루즈 출발 최소 3시간 전 항구에 도착하여 승선수속을 진행해야 하며, 귀국 항공편은 크루즈 도착 기준 약 5~6시간 이후로 예약하시기 바랍니다." },
  { text: "현재 제공되는 일부 이미지 및 고객 안내사항은 선내 또는 기항지에서 요구되거나 제한되는 공중보건 규칙과 정부 요건을 정확하게 반영하지 못할 수 있습니다." },
  {
    text: "이름변경",
    subItems: [
      "예약자 중 최소 1명의 이름은 그대로 유지되어야 합니다. 선사 재량에 따라 이름 변경 수수료 1인당 $50 발생할 수 있습니다."
    ]
  },
  {
    text: "일정 변경",
    subItems: [
      { type: "note", text: "[일정 변경 수수료]" },
      {
        text: "취소료 부과 이전 시점",
        subItems: [
          "무료 취소 가능 예약: 무료",
          "예약금 환불 불가(NRD) 예약: 매회 서비스 차지(1인당 USD 100)"
        ]
      },
      {
        text: "취소료 부과 시점",
        subItems: [
          "취소료 부과 시점부터는 예약 조건에 관계없이 해당 시점의 취소료가 적용됩니다.",
          "선사 사정에 따라 일정 변경이 불가할 수 있습니다."
        ]
      }
    ]
  },
  {
    text: "선상팁",
    subItems: [
      "선상팁을 사전 지불하지 않는 경우 선사 규정에 따라 선상팁은 추후 변경될 수 있습니다.",
      "로얄캐리비안 크루즈를 이용하는 모든 고객은 선상팁(Gratuities)을 지불해야하며, 선실 등급, 예약 시점에 따라 선상팁 비용이 상이합니다. 예약 완료 단계 내 '추가서비스'에서 선상팁 금액 확인 및 선지불 선택 가능합니다. 선상팁 후지불 선택 시, 추후 선사의 정책에 따라 금액이 변경 될 수 있습니다.",
      {
        text: "스위트 선실 이용 고객",
        subItems: [
          "1인 1박당 USD $21.00"
        ]
      },
      {
        text: "그 외 모든 선실 이용 고객",
        subItems: [
          "1인 1박당 USD $18.50"
        ]
      }
    ]
  },
  {
    text: "미성년자 탑승 규정",
    subItems: [
      "원칙: 미성년자(만 18세 이하) 승객은 최소 1명의 성인(Adult)과 동일 객실에 투숙해야 합니다.",
      "예외: 부모/법정대리인이 동반하지 않는 경우, 예약 시 예외 요청과 함께 부모/법정대리인의 동의서 및 지정 보호자 정보 등을 제출해야 합니다.",
      { type: "note", text: "*미국 출발 또는 미국을 여행(기항 포함)하는 크루즈의 경우 만 21세 이상 이어야 합니다." }
    ]
  },
  {
    text: "임산부 승선 규정",
    subItems: [
      "탑승 가능: 임신 주수가 23주 이하인 경우에 한해, 의사 소견서 및 임신 주수 증빙서류를 승선(출항) 30일 전까지 제출하면 승선 가능합니다.",
      "탑승 불가: 크루즈 기간 중 어느 시점이든 임신 24 초과가 되는 경우, 안전상 승선이 거절됩니다."
    ]
  },
  {
    text: "휠체어 반입 규정",
    subItems: [
      "사전 신고 필수: 휠체어/스쿠터는 승선 전 반드시 선사 측에 신고해야 하며, 사전 신고가 없을 경우 승선/반입이 거절될 수 있습니다.",
      "배터리 규정: 신고시, 배터리 유형을 Gel / Dry / Wet로 선택하도록 되어 있고, “배터리 타입”을 요구합니다.",
      "복도 보관 금지: 안전을 위해 복도/통로 보관은 불가하며, 객실 내 보관이 원칙입니다.",
      "터미널 승·하선 도움: 휠체어/거동 불편 고객은 부두에서 승·하선 보조 요청 가능하며, 이를 위해 출항 최소 30일 전 신청을 권장합니다."
    ]
  }
];

export const DISNEY_CAUTION = [
  { text: "상기 일정은 날씨(천재지변) 및 선사 사정에 따라서 사전 통보없이 변경될 수 있습니다." },
  { text: "크루즈 출발 최소 3시간 전 항구에 도착하여 승선수속을 진행해야 하며, 귀국 항공편은 크루즈 도착 기준 약 5~6시간 이후로 예약하시기 바랍니다." },
  { text: "현재 제공되는 일부 이미지 및 고객 안내사항은 선내 또는 기항지에서 요구되거나 제한되는 공중보건 규칙과 정부 요건을 정확하게 반영하지 못할 수 있습니다." },
  {
    text: "이름변경",
    subItems: [
      "예약자 중 최소 1명의 이름은 그대로 유지되어야 합니다. 선사 재량에 따라 이름 변경 수수료 1인당 $50 발생할 수 있습니다."
    ]
  },
  {
    text: "선상팁",
    subItems: [
      "선상팁을 사전 지불하지 않는 경우 선사 규정에 따라 선상팁은 추후 변경될 수 있습니다.",
      "디즈니크루즈를 이용하는 모든 고객은 선상팁을 지불해야하며, 등급에 따른 선상팁 비용은 아래와 같습니다.",
      {
        text: "내측 / 오션뷰 / 베란다",
        subItems: [
          "1인 1박당 USD $16"
        ]
      },
      {
        text: "컨시어지 / 스위트",
        subItems: [
          "1인 1박당 USD $27.25"
        ]
      }
    ]
  },
  {
    text: "미성년자 탑승 규정",
    subItems: [
      "원칙: 미성년자(만 18세이하) 승객은 최소 1명의 성인(Adult)과 동일 객실에 투숙해야 합니다.",
      "예외: 부모/법정대리인이 동반하지 않는 경우, 예약 시 예외 요청과 함께 부모/법정대리인의 동의서 및 지정 보호자 정보 등을 승선 전 제출해야 합니다.",
      { type: "note", text: "*미국 출발 또는 미국을 여행(기항 포함)하는 크루즈의 경우 단독 여행은 만 21세 이상이어야 합니다." }
    ]
  },
  {
    text: "임산부 승선 규정",
    subItems: [
      "탑승 가능: 임신 주수가 24주차 이하인 경우에 한해, 의사 소견서 및 임신 주수 증빙서류를 승선(출항) 30일 전까지 제출하면 승선 가능합니다.",
      "탑승 불가: 크루즈 기간 중 어느 시점이든 임신 24 초과가 되는 경우, 안전상 승선이 거절됩니다."
    ]
  },
  {
    text: "휠체어 반입 규정",
    subItems: [
      "사전 신고 필수: 휠체어/스쿠터는 승선 최소 30일 전 반드시 선사 측에 신고해야 하며, 사전 신고가 없을 경우 승선/반입이 거절될 수 있습니다.",
      "복도 보관 금지: 안전을 위해 복도/통로 보관은 불가하며, 객실 내 보관이 원칙입니다."
    ]
  }
];

export const resolveCautionByLineId = (lineId) => {
  const numericLineId = Number(lineId);
  if (numericLineId === MSC_LINE_ID) return MSC_CAUTION;
  if (numericLineId === NORWEGIAN_LINE_ID) return NORWEGIAN_CAUTION;
  if (numericLineId === ROYAL_CARIBBEAN_LINE_ID) return ROYAL_CARIBBEAN_CAUTION;
  if (numericLineId === DISNEY_LINE_ID) return DISNEY_CAUTION;
  return DEFAULT_CAUTION;
};
